import React from 'react';
import css from './EnergyFeature.module.css';

const stats = [
  { value: '10k+', label: 'Solar installations' },
  { value: '100k', label: 'Tons of CO2 reduced' },
  { value: '70%', label: 'Long-term savings' },
];

const EnergyFeature = () => {
  return (
    <section className={css.wrapper}>
      <div className={css.inner}>
        <div className={css.content}>
          <p className={css.kicker}>New Energy For Our System</p>
          <h2 className={css.title}><span>Clean</span> Renewable Limitless <span>Energy</span></h2>
          <p className={css.description}>
            Switch to solar with Solvate and experience cost-saving energy independence, and a greener and greater environment.
          </p>
          <button className={css.cta}>Get Free Consultation</button>
          <div className={css.statsRow}>
            {stats.map(item => (
              <div key={item.label} className={css.statCard}>
                <span className={css.statValue}>{item.value}</span>
                <span className={css.statLabel}>{item.label}</span>
              </div>
            ))}
          </div>
        </div>

        <div className={css.media}>
          <img
            src="https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1600"
            alt="Wind turbines across green hills"
            className={css.heroImage}
          />
          <div className={css.mediaOverlay}>
            <p className={css.overlayText}>Unlock the power of solar energy and enjoy long-term savings.</p>
            <button className={css.playButton} aria-label="Play intro video">
              <span className={css.playIcon}>▶</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EnergyFeature;
